import { combineReducers } from 'redux'
import { connectRouter } from 'connected-react-router'

import analytics from './analytics'
import auth from './auth'
import buddies from './buddies'
import claimTokens from './claimTokens'
import clubs from './clubs'
import connectedUnions from './connectedUnions'
import ghostUsers from './ghostUsers'
import guides from './guides'
import matches from './matches'
import metronome from './metronome'
import organisations from './organisations'
import profile from './profile'
import resetPassword from './resetPassword'
import shots from './shots'
import signup from './signup'
import teeCache from './teeCache'

export default function createRootReducer (history) {
  const appReducer = combineReducers({
    analytics,
    auth,
    buddies,
    claimTokens,
    clubs,
    connectedUnions,
    ghostUsers,
    guides,
    matches,
    metronome,
    organisations,
    profile,
    resetPassword,
    router: connectRouter(history),
    shots, // MATCHES/GAMES/SHOTS
    signup,
    teeCache
  })

  const rootReducer = (state, action) => {
    if (action.type === 'auth/LOGOUT' || action.type === 'auth/LOGIN_REQUEST') {
      const { router } = state
      state = { router }
    }

    return appReducer(state, action)
  }

  return rootReducer
}
